import { useState, type ReactNode } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import { CopyableField } from './CopyableField';

interface VendorGroupProps {
  vendorName: string;
  itemCount: number;
  earliestNeedBy: string | null;
  children: ReactNode;
  defaultExpanded?: boolean;
}

export function VendorGroup({
  vendorName,
  itemCount,
  earliestNeedBy,
  children,
  defaultExpanded = true,
}: VendorGroupProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className="bg-background rounded-lg border border-border overflow-hidden">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between px-4 py-3 bg-background-subtle hover:bg-background-muted transition-colors"
      >
        <div className="flex items-center gap-3">
          {isExpanded ? (
            <ChevronDown className="h-4 w-4 text-foreground-muted" />
          ) : (
            <ChevronRight className="h-4 w-4 text-foreground-muted" />
          )}
          <CopyableField value={vendorName} className="font-medium text-foreground" />
          <span className="text-xs text-foreground-muted bg-background px-2 py-0.5 rounded-full">
            {itemCount} item{itemCount !== 1 ? 's' : ''}
          </span>
        </div>
        {earliestNeedBy && (
          <span className="text-xs text-foreground-muted">
            Earliest need: {format(parseISO(earliestNeedBy), 'MMM d')}
          </span>
        )}
      </button>

      {isExpanded && <div>{children}</div>}
    </div>
  );
}
